export default __webpack_public_path__ + "static/media/game-guide-desktop.23b9b01e.jpg";